import WhyChooseUs from './WhyChooseUs';

export default WhyChooseUs;
